/**
 * Portal_UserImpersonations.Memo and sProc_Portal_UserImpersonations_I
 * @Memo are NVARCHAR(50). The impersonation dialog must stop at the same
 * length (Bug 80756).
 */
export const IMPERSONATION_MEMO_MAX_LENGTH = 50;

export const limitImpersonationMemo = (value: string): string =>
  value.slice(0, IMPERSONATION_MEMO_MAX_LENGTH);
